import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { TitoliFormComponent } from '../../../form/titoli/titoli-form.component';
import { SezioneTitoli } from '../../../models/sezioni/sezione-titoli';
import { TitoloEsecutivo } from '../../../models/titolo-esecutivo';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [titolo-form-update]',
  templateUrl: '../../../form/titoli/titoli-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class TitoloUpdateConcreteFormComponent extends TitoliFormComponent implements OnInit {

  idSezione: string;
  titolo: TitoloEsecutivo;
  urlUpdate: string;

  @Output()
  onReturn: EventEmitter<SezioneTitoli> = new EventEmitter<SezioneTitoli>();

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica dati - Titolo');
    this.isInserimento(false);
  }

  getTitolo() {
    return this.titolo;
  }

  getRequest(request: TitoloEsecutivo) {
    this.operationService.updateTitolo(this.urlUpdate, request, this.idSezione).subscribe(response => this.sezioneTitoliUpdated(response));
  }

  sezioneTitoliUpdated(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(url: string, titolo: TitoloEsecutivo, idSezione: string) {
    this.urlUpdate = url;
    this.titolo = titolo;
    this.idSezione = idSezione;
    this.createForm();
    this.populateSelect();
  }
}
